import { INSURANCE_URLS } from 'constants/urls'

export const INSURANCE = INSURANCE_URLS
